import {
    Button,
    LinearProgress,
    Table,
    TableBody,
    TableHead,
    TableRow,
  } from "@material-ui/core";
  import TableCell from "@material-ui/core/TableCell";
  import Typography from "@material-ui/core/Typography";
  import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";
  import { CSSProperties } from "@material-ui/core/styles/withStyles";
  import * as format from "date-fns/format";
  import * as React from "react";
  import ReactPaginate from "react-paginate";
  import CloseIcon from "@material-ui/icons/Close";
  import { Dialog, DialogTitle, DialogContent,IconButton  } from "@material-ui/core";
  import {
    ICoach,
    IScaleQuestionAndResponse,
    ISport,
    ISurveyEvaluationRequest,
    ISurveyEvaluationResponse,
    ISurveyEvaluationResponses,
    IWrittenQuestionAndResponse,
    IWrittenResponse,
    TemplateQuestionCategory,
  } from "src/api/types";
  import Component from "src/shared/components/Component";
  import Modal, { IModalProps } from "src/shared/components/Modal";
  import withAxios, { IAxiosProps } from "src/shared/components/withAxios";
  import l from "src/l";
  import { roundToTen } from "src/util";
  import {
    CANCEL_TEXT,
    DELETE_TEXT,
    // GET_DELETE_CONFIRMATION_TEXT,
  } from "./constants";
  import "./pagination.css";
  
  const styles = (theme: Theme): Record<string, CSSProperties> => ({
    modal: {
      height: "80%",
      width: "80%",
    },
    summaryBox: {
      backgroundColor: "#efefef",
      border: "1px solid #424242",
      borderRadius: 4,
      padding: `${theme.spacing(1)}px ${theme.spacing(1)}px ${theme.spacing(
        1
      )}px ${theme.spacing(1)}px`,
    },
    text: {
      overflowWrap: "break-word",
      whiteSpace: "pre-wrap",
    },
  });
  
  interface IExtraProps {
    slug: string;
    schoolId: number;
    surveyId: number;
    coach: ICoach;
    sport: ISport;
    startDate: number;
    endDate: number;
    isParentModal?: "true" | "false";
    schoolData:any
  }
  
  type IBaseProps = IModalProps & IExtraProps;
  
  type IProps = IBaseProps &
    IAxiosProps &
    WithStyles<keyof ReturnType<typeof styles>>;
  
  interface ISurveyResponsesModalState {
    loading?: true;
    index: number;
    surveyResponse?: ISurveyEvaluationResponses;
    showDeleteConfirmation?: true;
    isDeleting?: true;
  }
  
  export default withStyles(styles, { withTheme: true })(
    withAxios(
      class CoachResponsesModal extends Component<
        IProps,
        ISurveyResponsesModalState
      > {
        public readonly state = this.buildState({
          index: 0,
        });
  
        public componentDidMount() {
          void this.loadAsync();
        }
  
        public render() {
          const { open, classes } = this.props;
          return (
            <Modal
              open={open}
              closeModal={this.props.closeModal}
              className={classes.modal}
            >
              {this.renderResponses()}
            </Modal>
          );
        }
  
        private renderResponses() {
          const { loading, surveyResponse } = this.state;
          if (loading) {
            return <LinearProgress variant="query" />;
          }
          if (surveyResponse === undefined) {
            return <span>Oops... something went wrong</span>;
          }
          return <div>{this.renderData(surveyResponse)}</div>;
        }
  
        private renderData(surveyResponse: ISurveyEvaluationResponses) {
          const { isParentModal = "false" } = this.props;
  console.log("surveyResponse", surveyResponse.surveyResponses)
          return (
            <div>
              {this.renderHeader()}
              <div
                style={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                {this.renderPagination(surveyResponse)}
                {surveyResponse.surveyResponses.length === 0 && (
                  <h1 style={{ color: "red" }}>There are 0 {this.props?.schoolData?.isAdSurvey === true ? "AD" : "Coach"} responses</h1>
                )}
                {this.renderDelete(surveyResponse)}
              </div>
             {/* 
                {this.renderRespondentName(surveyResponse)}
                */}
              <Table>
                {isParentModal === "true" ? (
                  <>
                    {this.renderScaleQuestionsCategory(
                      this.filterScaleCategory(
                        surveyResponse.scaleSurveyQuestionResponses,
                        TemplateQuestionCategory.parent
                      ),
                      "Parent Responses",
                      surveyResponse.surveyResponses
                    )}
                  </>
                ) : (
                  <>
                    <div style={{ marginTop: "1.25rem" }}>
                      {this.renderScaleQuestionsCategory(
                        this.filterScaleCategory(
                          surveyResponse.scaleSurveyQuestionResponses,
                          TemplateQuestionCategory.expectations
                        ),
                        "Expectations",
                        surveyResponse.surveyResponses
                      )}
                    </div>
                    <div style={{ marginTop: "1.25rem" }}>
                      {this.renderScaleQuestionsCategory(
                        this.filterScaleCategory(
                          surveyResponse.scaleSurveyQuestionResponses,
                          TemplateQuestionCategory.warmth
                        ),
                        "Relational Warmth",
                        surveyResponse.surveyResponses
                      )}
                    </div>
                    <div style={{ marginTop: "1.25rem" }}>
                      {this.renderScaleQuestionsCategory(
                        this.filterScaleCategory(
                          surveyResponse.scaleSurveyQuestionResponses,
                          TemplateQuestionCategory.other
                        ),
                        "Written Response",
                        surveyResponse.surveyResponses
                      )}
                    </div>
                  </>
                )}
              </Table>
              <div style={{ marginTop: "1.25rem" }}>
                {this.renderWrittenQuestions(
                  surveyResponse.writtenQuestionsResponses,
                  surveyResponse.surveyResponses
                )}
              </div>
              <div style={{ marginTop: "1.25rem" }}>
              {/* 
                {this.renderRespondentName(surveyResponse)}
                */}
                {this.renderPagination(surveyResponse)}
              </div>
            </div>
          );
        }
  
        private renderHeader() {
          const { coach, sport, startDate, endDate } = this.props;
          const sportName = this.props?.schoolData?.isAdSurvey === true
            ? "Athletic Director"
            : sport.name.trim();
          return (
            <span>
              <Typography variant="h3">
                {coach.name.trim()}{this.props?.schoolData?.isEmbeddable === true ? "" : `: ${sportName}`}
              </Typography>
              <Typography variant="h3">{`${format(
                startDate,
                "MMMM D, YYYY"
              )} to ${format(endDate, "MMMM D, YYYY")}`}</Typography>
            </span>
          );
        }
  
        // private renderRespondentName(surveyResponse: ISurveyEvaluationResponses) {
        //   const { index } = this.state;
        //   if (surveyResponse.surveyResponses[index] === undefined) {
        //     return <div>no respondent</div>;
        //   }
        //   return (
        //     <div>Are you sure you would like to delete this respons
        //       <Typography>
        //         Respondent Name:{" "}
        //         <strong>
        //           {surveyResponse.surveyResponses[index].respondentName}
        //         </strong>
        //       </Typography>
        //     </div>
        //   );
        // }
  
        private renderDelete(surveyResponse: ISurveyEvaluationResponses) {
          const { index, showDeleteConfirmation, isDeleting } = this.state;
  
          if (surveyResponse.surveyResponses[index] === undefined) {
            return;
          }
          return (
            <>
              {showDeleteConfirmation ? (
                <div style={{ padding: "0.25rem" }}>
                  <Dialog open={true} > 
                      <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontWeight: "600",
                        padding: "10px 15px",
                        }} > 
                        <DialogTitle style={{padding: "0",}}>
                            Confirm Delete
                          
                        </DialogTitle>
                            <IconButton
                              aria-label="close"
                              onClick={this.showDeleteConfirmation(undefined)}
                              size="small"
                              style={{ color: "#888" }}
                            >
                            <CloseIcon />
                        </IconButton>
                        </div>
                    <DialogContent style={{ padding: "0 15px 5px 15px" }}>
                      <p>
                        {/* {GET_DELETE_CONFIRMATION_TEXT(
                          surveyResponse.surveyResponses[index].respondentName
                        )} */}
                        Are you sure you would like to delete this response?
                      </p>
                    </DialogContent> 
                      <div
                        style={{
                          display: "grid",
                          gridGap: "1rem",
                          gridTemplateColumns: "1fr 1fr",
                          padding: "0 15px 10px 15px",
                        }}
                      >
                    <Button
                      onClick={this.deleteSurveyResponse(
                        surveyResponse.surveyResponses[index].id
                      )}
                      variant="contained"
                      color="secondary"
                    >
                      {DELETE_TEXT}
                    </Button>
                    <Button onClick={this.showDeleteConfirmation(undefined)}>
                      {CANCEL_TEXT}
                    </Button>
                  </div>
                   </Dialog>
                </div>
              ) : (
                <div>
                  {isDeleting && <LinearProgress />}
                  <Button
                    style={{ backgroundColor: "#be0000", color: "white" }}
                    onClick={this.showDeleteConfirmation(true)}
                  >
                    Delete
                  </Button>
                </div>
              )}
            </>
          );
        }
  
        private readonly showDeleteConfirmation =
          (show: true | undefined) => () =>
            this.setState({ showDeleteConfirmation: show });
  
        private deleteSurveyResponse = (surveyResponseId: number) => async () => {
          const { surveyId, schoolId } = this.props;
          await this.runCancellableStatefulAsync(
            this,
            {
              isDeleting: true,
            },
            {
              isDeleting: undefined,
              showDeleteConfirmation: undefined,
            },
            async () => {
              const { surveyResponse } = this.state;
              await this.buildDeleteWithParams<{}, { schoolId: number }>(
                this,
                l`survey/${surveyId}/${surveyResponseId}`
              )({
                schoolId,
              });
              await this.buildDeleteWithParams<any, any>(
                this,
                l`survey/delete/${surveyId}`
              );
              await this.loadAsync();
              if (surveyResponse === undefined) {
                return;
              }
              console.log(
                " I am making the index right",
                Math.min(
                  this.state.index,
                  surveyResponse.surveyResponses.length - 1
                )
              );
              // Make sure index is not over
              this.setState((prevState) => {
                return {
                  index: Math.max(
                    0,
                    Math.min(
                      prevState.index,
                      surveyResponse.surveyResponses.length - 2
                    )
                  ),
                };
              });
            },
            () => {
              this.setState({ isDeleting: undefined });
              window.alert("Failed to delete survey response.");
            }
          );
        };
  
        private renderPagination(surveyResponse: ISurveyEvaluationResponses) {
          return (
            <nav>
              <ReactPaginate
                forcePage={this.state.index}
                pageCount={surveyResponse.surveyResponses.length}
                previousLabel={"previous"}
                nextLabel={"next"}
                breakClassName={"pagination-break"}
                marginPagesDisplayed={1}
                pageRangeDisplayed={15}
                containerClassName={"pagination"}
                activeClassName={"active"}
                onPageChange={this.onSurveyRespondChange}
              />
            </nav>
          );
        }
  
        private onSurveyRespondChange = (data: { selected: number }) => {
          this.setState({
            index: data.selected,
            showDeleteConfirmation: undefined,
          });
        };
  
        private renderScaleQuestionsCategory(
          data: IScaleQuestionAndResponse[],
          heading: string,
          surveyResponses: ISurveyEvaluationResponse[]
        ) {
          const { classes } = this.props;
          const { index } = this.state;
          if (data.length === 0) {
            return null;
          }
          return (
            <>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: "100%" }}>
                    <Typography variant="h4" style={{ fontWeight: "bold" }}>
                      {heading}
                    </Typography>
                  </TableCell>
                  <TableCell>Value</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((d, i: number) => {
                  const getText = () => {
                    if (surveyResponses[index] === undefined) {
                      return;
                    }
                    const response = d.responses.find(
                      (dr) => dr.surveyResponseId === surveyResponses[index].id
                    );
                    if (response === undefined) {
                      return;
                    }
                    return roundToTen(response.response);
                  };
                  return (
                    <TableRow key={i}>
                      <TableCell
                        component="th"
                        scope="row"
                        className={classes.text}
                      >
                        {d.question.text}
                      </TableCell>
                      <TableCell>{getText()}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </>
          );
        }
  
        private renderWrittenQuestions(
          data: IWrittenQuestionAndResponse[],
          surveyResponses: ISurveyEvaluationResponse[]
        ) {
          return (
            <div>
              {data.map(
                (d, i) =>
                  d.question.text &&
                  this.renderWrittenQuestion(d, i, surveyResponses)
              )}
            </div>
          );
        }
  
        private renderWrittenQuestion(
          d: IWrittenQuestionAndResponse,
          i: number,
          surveyResponses: ISurveyEvaluationResponse[]
        ) {
          const { classes } = this.props;
          const { index } = this.state;
  
          return (
            <div key={i} style={{ marginTop: "0.5rem" }}>
              <div className={`${classes.text}`}>{d.question.text}</div>
              <div className={`${classes.text} ${classes.summaryBox}`}>
                {(() => {
                  if (surveyResponses[index] === undefined) {
                    return;
                  }
                  return this.renderWrittenResponse(
                    d.responses.find(
                      (dr) => dr.surveyResponseId === surveyResponses[index].id
                    )
                  );
                })()}
              </div>
            </div>
          );
        }
  
        private renderWrittenResponse(d: IWrittenResponse | undefined) {
          if (d === undefined) {
            return;
          }
          return <div>{d.response}</div>;
        }
  
        private filterScaleCategory(
          data: IScaleQuestionAndResponse[],
          category: number
        ) {
          return data.filter((d) => d.question.category === category);
        }
  
        private readonly loadAsync = async () => {
          const { isParentModal = "false" } = this.props;
  
          await this.runCancellableStatefulAsync(
            this,
            {
              loading: true,
            },
            {
              loading: undefined,
            },
            async () => {
              const { surveyId, coach } = this.props;
              const surveyResponse = await this.buildGetWithParams<
                ISurveyEvaluationResponses,
                ISurveyEvaluationRequest
              >(
                this,
                l`surveys/${surveyId}/evaluations/coach/${coach.id}`
              )({
                isParentResponses: isParentModal,
                schoolSlug: this.props.slug,
              });
              this.setState({ surveyResponse });
            },
            () => {
              this.setState({
                loading: undefined,
              });
            }
          );
        };
      }
    )
  );



// WEBPACK FOOTER //
// ./src/features/director/pages/evaluation/coachResponsemodal.tsx